import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'app-timer-modal',
	templateUrl: './timer-modal.component.html',
	styleUrls: ['./timer-modal.component.scss']
})
export class TimerModalComponent implements OnInit {
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input('component') componentData;
	@Input() random;
	@Output() output = new EventEmitter<any>();
	WrapperHeight = window.innerHeight * 0.9 - 340;
	background;
	selectedElement;
	canvasHeight;
	canvasWidth;
	backup = [];
	backupLabels = [];
	backupBasic = {};
	basicRegEx = new RegExp(/%D|%H|%I|%A|%S/, 'g');
	basicText = '';

	constructor(private sanitation: DomSanitizer) {}

	ngOnInit() {
		if (this.componentData.config.base.text.format != 'advanced' && this.componentData.config.version >= 3) {
			this.basicText = this.componentData.config.base.text.format.replace(this.basicRegEx, '00');
			this.backupBasic = { ...this.componentData.config.base.text.basic };
		}

		this.componentData.config.base.text.elements.forEach((element) => {
			this.backup.push(Object.values(element));
		});

		if (this.componentData.config.version >= 3 && this.componentData.config.labels.include_labels) {
			this.componentData.config.labels.elements.forEach((element) => {
				this.backupLabels.push(Object.values(element));
			});
		}

		if (this.componentData.config.base.background['background-image']) {
			this.background = this.sanitation.bypassSecurityTrustStyle(
				'url(' + this.componentData.config.base.background['background-image'] + ') 0 0 no-repeat'
			);
		} else {
			this.background = this.componentData.config.base.background['background-color'];
		}

		this.canvasHeight = this.componentData.config.base.background.height * 1.5;
		if (this.canvasHeight > 800) {
			this.canvasHeight == 800;
		}
		this.canvasWidth = this.componentData.config.base.background.width * 1.5;
		if (this.canvasWidth > 800) {
			this.canvasWidth == 800;
		}
	}

	updatePosition(event, index) {
		this.output.emit({ method: 'updatePosition', element: index, data: event });
	}

	updateLabelPosition(event, index) {
		this.output.emit({ method: 'updateLabelPosition', element: index, data: event });
	}

	updateBasicPosition(event, index) {
		this.output.emit({ method: 'updateBasicPosition', element: index, data: event });
	}

	alignHorizontalPositions() {
		if (this.componentData.config.horizontal_lock) {
			this.componentData.config.vertical_lock = false;
			this.alignStart();
		}
	}

	alignVerticalPositions() {
		if (this.componentData.config.vertical_lock) {
			this.componentData.config.horizontal_lock = false;
			this.alignStart();
		}
	}

	alignStart() {
		let startingPositions = {
			top: this.componentData.config.base.text.elements[0].top,
			left: this.componentData.config.base.text.elements[0].left
		};
		this.output.emit({ method: 'updatePosition', element: 0, data: startingPositions });
		if (this.componentData.config.labels.include_labels) {
			this.outputLabels();
		}
	}

	outputLabels() {
		let startingLabelPositions = {
			top: this.componentData.config.labels.elements[0].top,
			left: this.componentData.config.labels.elements[0].left
		};
		this.output.emit({ method: 'updateLabelPosition', element: 0, data: startingLabelPositions });
	}

	savePositions() {
		this.output.emit({ method: 'savePositions' });
	}

	cancel() {
		if (this.componentData.config.base.text.format != 'advanced') {
			this.output.emit({ method: 'cancelBasic', data: this.backupBasic });
		} else {
			if (this.componentData.config.labels.include_labels) {
				this.output.emit({ method: 'cancel', data: this.backup, labels: this.backupLabels });
			} else {
				this.output.emit({ method: 'cancel', data: this.backup });
			}
		}
	}

	toggleFocus(elm) {
		this.selectedElement = elm;
	}
}
